import { CurrencyCodes } from '@generated/graphql';

/**
 * Threshold for determining if a withdrawal is a "full withdrawal"
 * If amount >= available * threshold, it's considered full
 */
export const FULL_WITHDRAWAL_THRESHOLD = 0.98;

/**
 * Threshold for showing "amount exceeds available" warning
 */
export const EXCEEDS_AVAILABLE_THRESHOLD = 0.97;

/**
 * Spread used for illiquid portfolio estimate calculations
 */
export const ILLIQUID_PORTFOLIO_ESTIMATE_SPREAD = 0.05;

/**
 * Default exchange rate when no conversion is needed or rate fetch fails
 */
export const DEFAULT_EXCHANGE_RATE = 1;

/**
 * Base currency for fee calculations (fees are always calculated in CAD first)
 */
export const FEE_BASE_CURRENCY = CurrencyCodes.Cad;
